export default {
  data: () => ({
    translations: {
      title: {
        el: 'Λογότυπο Προγραμματος Ποντοδοσίας',
        en: 'Loyalty Logo',
        it: 'Logo del Loyalty',
      },
      info_points: {
        el: 'Ανεβάστε ένα λογότυπο που θα εμφανίζεται στην εφαρμογή, για το πρόγραμμα επιβράβευσης και την ετικέτα των πόντων σας.',
        en: `Upload a logo to appear in app, next to your loyalty program and your points label.`,
        it: "Carica un logo che apparirà nell'app, accanto al tuo programma di fedeltà e all'etichetta dei tuoi punti.",
      },
      info_cashback: {
        el: 'Ανεβάστε ένα λογότυπο που θα εμφανίζεται στην εφαρμογή, για το πρόγραμμα επιβράβευσης και την ετικέτα του cashback σας.',
        en: `Upload a logo to appear in app, next to your loyalty program and your cashback label.`,
        it: "Carica un logo che apparirà nell'app, accanto al tuo programma di fedeltà e all'etichetta del tuo cashback.",
      },
      uploadText: {
        el: 'Πατήστε στο κουμπί για να επιλέξετε εικόνα:',
        en: 'Click inside the field to open the file selection tab:',
        it: "Tocca il pulsante per selezionare un'immagine:",
      },
      validationError: {
        el: 'Για να συνεχίσετε πρέπει να ανεβάσετε μια νέα εικόνα',
        en: 'To continue you must upload a new image',
        it: 'Per continuare è necessario caricare una nuova immagine',
      },
    },
  }),
};
